import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './i18n';
import '@/App.css';
import LanguageLayout from './components/LanguageLayout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import { PrivacyPage, CookiesPage, TermsPage } from './pages/Legal';
import ThankYou from './pages/ThankYou';
import { reHydrateOnLoad } from './consent/consent';

function RootRedirect() {
  const browserLang = (typeof navigator !== 'undefined' && navigator.language) || 'it';
  const target = browserLang.toLowerCase().startsWith('en') ? '/en' : '/it';
  return <Navigate to={target} replace />;
}

function App() {
  useEffect(() => {
    reHydrateOnLoad();
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/thank_you" element={<ThankYou />} />
        <Route path="/:lang" element={<LanguageLayout />}>
          <Route index element={<Home />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="cookies" element={<CookiesPage />} />
          <Route path="terms" element={<TermsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/it" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
